/* THIS FILE IS AUTO-GENERATED. DO NOT EDIT. */

export const FF = Object.freeze({
  ANNOUNCEMENT_BANNER: 'ANNOUNCEMENT_BANNER',
  ANNOUNCEMENT_QA_OVERRIDES: 'ANNOUNCEMENT_QA_OVERRIDES',
  ANATOMIC_NAVIGATOR: 'ANATOMIC_NAVIGATOR',
  AIM_AUTO_POPULATE: 'AIM_AUTO_POPULATE',
  AUTOLOAD_PRIORS: 'AUTOLOAD_PRIORS',
  CLEAR_PATIENT_CONTEXT: 'CLEAR_PATIENT_CONTEXT',
  EDIT_CASE_PRIORITY: 'EDIT_CASE_PRIORITY',
  ENABLE_REPORTER_SUBMISSION: 'ENABLE_REPORTER_SUBMISSION',
  ENFORCE_CLAIM_EXAM_RBAC: 'ENFORCE_CLAIM_EXAM_RBAC',
  EXAM_GROUPED_HANGING_PROTOCOLS: 'EXAM_GROUPED_HANGING_PROTOCOLS',
  DICOM_DATA_SERIES_DOWNLOAD: 'DICOM_DATA_SERIES_DOWNLOAD',
  DICOM_DATA_STUDY_DOWNLOAD: 'DICOM_DATA_STUDY_DOWNLOAD',
  DICOM_DATA_SERIES_SLICES_DOWNLOAD: 'DICOM_DATA_SERIES_SLICES_DOWNLOAD',
  DICOM_DATA_INSTANCE_TAGS: 'DICOM_DATA_INSTANCE_TAGS',
  DICOM_DATA_VIEWER_STACK: 'DICOM_DATA_VIEWER_STACK',
  GSPS_ANNOTATIONS: 'GSPS_ANNOTATIONS',
  HANGING_PROTOCOL_PHASE: 'HANGING_PROTOCOL_PHASE',
  HIDE_ARCHIVE: 'HIDE_ARCHIVE',
  IMAGE_BOOKMARK: 'IMAGE_BOOKMARK',
  KEEP_BACKGROUND_TAB_ACTIVE: 'KEEP_BACKGROUND_TAB_ACTIVE',
  LLM_REPORT_POST_PROCESSING: 'LLM_REPORT_POST_PROCESSING',
  MIN_COLUMNS_TO_ENABLE_MULTIPLE_EXPANSION_AREAS: 'MIN_COLUMNS_TO_ENABLE_MULTIPLE_EXPANSION_AREAS',
  PATIENT_JACKET_EXAM_COMMENTS: 'PATIENT_JACKET_EXAM_COMMENTS',
  PIXEL_WORKER_DEDUPLICATION: 'PIXEL_WORKER_DEDUPLICATION',
  VIEWER_SW_PORT_PRUNING: 'VIEWER_SW_PORT_PRUNING',
  VIEWER_SW_GENERATION_BUMP: 'VIEWER_SW_GENERATION_BUMP',
  PREFETCH_CLAIMED_WORKLIST_ITEMS: 'PREFETCH_CLAIMED_WORKLIST_ITEMS',
  PREFETCH_HOVERED_WORKLIST_ITEM: 'PREFETCH_HOVERED_WORKLIST_ITEM',
  PREFETCH_READ_CASE_ITEM: 'PREFETCH_READ_CASE_ITEM',
  PREFETCH_TOP_WORKLIST_ITEMS: 'PREFETCH_TOP_WORKLIST_ITEMS',
  PREFETCH_TOP_WORKLIST_ITEMS_BIG_BATCHING: 'PREFETCH_TOP_WORKLIST_ITEMS_BIG_BATCHING',
  PREFETCH_TOP_WORKLIST_ITEMS_LARGE: 'PREFETCH_TOP_WORKLIST_ITEMS_LARGE',
  PREFETCH_TOP_WORKLIST_FULL_STACKS: 'PREFETCH_TOP_WORKLIST_FULL_STACKS',
  PREFETCH_FULL_STACK_MAX_MB_PER_CASE: 'PREFETCH_FULL_STACK_MAX_MB_PER_CASE',
  REPORT_FACADE: 'REPORT_FACADE',
  REPORTER_ANATOMIC_NAVIGATOR: 'REPORTER_ANATOMIC_NAVIGATOR',
  REPORTER_ASR_PLEX: 'REPORTER_ASR_PLEX',
  REPORTER_AUTO_IMPRESSIONS: 'REPORTER_AUTO_IMPRESSIONS',
  REPORTER_AUTO_IMPRESSIONS_MODALITY_SCOPE: 'REPORTER_AUTO_IMPRESSIONS_MODALITY_SCOPE',
  REPORTER_DICTATION_MARKS: 'REPORTER_DICTATION_MARKS',
  REPORTER_EXPANDED_GROUPABLE_STATUSES: 'REPORTER_EXPANDED_GROUPABLE_STATUSES',
  REPORTER_HEADING_NODES_DEPRECATED: 'REPORTER_HEADING_NODES_DEPRECATED',
  REPORTER_HIDE_HYPOTHESIS_TEXT: 'REPORTER_HIDE_HYPOTHESIS_TEXT',
  REPORTER_MARK_AS_DISCREPANT: 'REPORTER_MARK_AS_DISCREPANT',
  REPORTER_MACRO_PLACEHOLDER_CHIP: 'REPORTER_MACRO_PLACEHOLDER_CHIP',
  REPORTER_NESTED_MACROS: 'REPORTER_NESTED_MACROS',
  REPORTER_PICKLIST_OPTION_BY_NAME: 'REPORTER_PICKLIST_OPTION_BY_NAME',
  REPORTER_PROGRAMMABLE_MICROPHONE_BUTTONS: 'REPORTER_PROGRAMMABLE_MICROPHONE_BUTTONS',
  REPORTER_RECORD_BUTTON_REDESIGN: 'REPORTER_RECORD_BUTTON_REDESIGN',
  REPORTER_RIGHT_DRAWER_TABLE_VIRTUALIZATION: 'REPORTER_RIGHT_DRAWER_TABLE_VIRTUALIZATION',
  REPORTER_SHOW_DICTATION_STEP_NOTIFICATIONS: 'REPORTER_SHOW_DICTATION_STEP_NOTIFICATIONS',
  REPORTER_TEXT_EDITOR_RECORDER_BORDER: 'REPORTER_TEXT_EDITOR_RECORDER_BORDER',
  REPORTER_WORKSTATION_ID: 'REPORTER_WORKSTATION_ID',
  REPORTER_WEBHID: 'REPORTER_WEBHID',
  REPORT_CONTENT_UNMASKED: 'REPORT_CONTENT_UNMASKED',
  SEARCH_PAGE: 'SEARCH_PAGE',
  SHOW_MOUSE_SENSITIVITY_SETTINGS: 'SHOW_MOUSE_SENSITIVITY_SETTINGS',
  SLATE_OPS_LOG: 'SLATE_OPS_LOG',
  URT_ENABLED: 'URT_ENABLED',
  USE_INVERTED_IMAGE_DETECTION: 'USE_INVERTED_IMAGE_DETECTION',
  VIEWER_RESET_CACHE_ON_REFRESH: 'VIEWER_RESET_CACHE_ON_REFRESH',
  VIEWER_PRECACHE_WAIT_FOR_STUDY_READY: 'VIEWER_PRECACHE_WAIT_FOR_STUDY_READY',
  VIEWER_MEMORY_OFFSET_GB: 'VIEWER_MEMORY_OFFSET_GB',
  VIEWER_MACHINE_MEMORY_BUDGET: 'VIEWER_MACHINE_MEMORY_BUDGET',
  VIEWER_SLICE_MEMORY_OVERHEAD_FACTOR: 'VIEWER_SLICE_MEMORY_OVERHEAD_FACTOR',
  VIEWER_RESTRICT_INITIAL_LOADS: 'VIEWER_RESTRICT_INITIAL_LOADS',
  VIEWER_STEP_AWARE_LOAD_PRIORITY: 'VIEWER_STEP_AWARE_LOAD_PRIORITY',
  VIEWER_CACHE_STRATEGY: 'VIEWER_CACHE_STRATEGY',
  VIEWER_MAX_PARALLEL_PIXEL_REQUESTS: 'VIEWER_MAX_PARALLEL_PIXEL_REQUESTS',
  VIEWER_RECORD_BUTTON: 'VIEWER_RECORD_BUTTON',
  WORKLIST_AUTO_LOAD: 'WORKLIST_AUTO_LOAD',
  WORKLIST_AUTOLOAD_BACKEND: 'WORKLIST_AUTOLOAD_BACKEND',
  WORKLIST_COLUMN_MANAGEMENT_DRAWER: 'WORKLIST_COLUMN_MANAGEMENT_DRAWER',
  WORKLIST_COUNT_CACHE_TTL_MS: 'WORKLIST_COUNT_CACHE_TTL_MS',
  WORKLIST_CONTEXT_REFACTOR: 'WORKLIST_CONTEXT_REFACTOR',
  WORKLIST_DICOM_SEND: 'WORKLIST_DICOM_SEND',
  WORKLIST_PERFORMANCE_OPTIMIZATION: 'WORKLIST_PERFORMANCE_OPTIMIZATION',
  WORKLIST_INGESTION_TIMEOUT: 'WORKLIST_INGESTION_TIMEOUT',
  WORKLIST_PENDING_TO_READY_TO_READ: 'WORKLIST_PENDING_TO_READY_TO_READ',
  WORKLIST_POLL_INTERVAL: 'WORKLIST_POLL_INTERVAL',
  WORKLIST_RECENTLY_READ_DAYS: 'WORKLIST_RECENTLY_READ_DAYS',
  WORKLIST_REPORT_STATUS_COLUMN: 'WORKLIST_REPORT_STATUS_COLUMN',
  WORKLIST_STICKY_FILTERS_DISABLED: 'WORKLIST_STICKY_FILTERS_DISABLED',
  WORKLIST_TABLE_REFACTOR: 'WORKLIST_TABLE_REFACTOR',
  WORKLIST_UNIFIED_FIELDS: 'WORKLIST_UNIFIED_FIELDS',
  WORKLIST_SLA: 'WORKLIST_SLA',
  WORKSPACE_LAYOUT_V2: 'WORKSPACE_LAYOUT_V2',
  refresh_viewer_on_new_case: 'refresh_viewer_on_new_case',
  REFRESH_REPORTER_ON_NEW_CASE: 'REFRESH_REPORTER_ON_NEW_CASE',
  VIEWPORT_TYPE_THREE_D_DRE_ENABLED: 'VIEWPORT_TYPE_THREE_D_DRE_ENABLED',
  IMAGE_REGISTRATION_ALIGNMENT: 'IMAGE_REGISTRATION_ALIGNMENT',
  IMAGE_REGISTRATION_MODEL_VERSION: 'IMAGE_REGISTRATION_MODEL_VERSION',
  PET_CT_OVERLAY_ENABLED: 'PET_CT_OVERLAY_ENABLED',
  REPORTER_EXAM_COUNT: 'REPORTER_EXAM_COUNT',
  FAST_ANNOTATIONS: 'FAST_ANNOTATIONS',
  REPORTER_MODIFY_DICTATION: 'REPORTER_MODIFY_DICTATION',
  MG_CAD_SR_TEXT_RENDER: 'MG_CAD_SR_TEXT_RENDER',
  MOVE_TO_QUALITY_CONTROL: 'MOVE_TO_QUALITY_CONTROL',
  ARCHIVE_SEARCH: 'ARCHIVE_SEARCH',
  REPORTER_PRELIM: 'REPORTER_PRELIM',
  QC_STATUS_COLUMN: 'QC_STATUS_COLUMN',
  DICOM_EDITING: 'DICOM_EDITING',
  PET_CT_SUV_EDITABLE: 'PET_CT_SUV_EDITABLE',
  LOCALIZE_MULTI_AXES: 'LOCALIZE_MULTI_AXES',
  DICOM_RESTORE: 'DICOM_RESTORE',
  DICOM_MISMATCH: 'DICOM_MISMATCH',
  MULTI_OBJECT_STACKS: 'MULTI_OBJECT_STACKS',
  WINDOW_LEVEL_DIRECT_MANIPULATION: 'WINDOW_LEVEL_DIRECT_MANIPULATION',
  SESSION_REPLAY_CONFIG: 'SESSION_REPLAY_CONFIG',
});
export const FFDefaults = Object.freeze({
  ANNOUNCEMENT_BANNER: 'off',
  ANNOUNCEMENT_QA_OVERRIDES: 'off',
  ANATOMIC_NAVIGATOR: 'off',
  AIM_AUTO_POPULATE: 'off',
  AUTOLOAD_PRIORS: 'on',
  CLEAR_PATIENT_CONTEXT: 'off',
  EDIT_CASE_PRIORITY: 'on',
  ENABLE_REPORTER_SUBMISSION: 'on',
  ENFORCE_CLAIM_EXAM_RBAC: 'off',
  EXAM_GROUPED_HANGING_PROTOCOLS: 'off',
  DICOM_DATA_SERIES_DOWNLOAD: 'off',
  DICOM_DATA_STUDY_DOWNLOAD: 'off',
  DICOM_DATA_SERIES_SLICES_DOWNLOAD: 'off',
  DICOM_DATA_INSTANCE_TAGS: 'off',
  DICOM_DATA_VIEWER_STACK: 'off',
  GSPS_ANNOTATIONS: 'on',
  HANGING_PROTOCOL_PHASE: 'phase-2',
  HIDE_ARCHIVE: 'off',
  IMAGE_BOOKMARK: 'on',
  KEEP_BACKGROUND_TAB_ACTIVE: 'none',
  LLM_REPORT_POST_PROCESSING: 'off',
  MIN_COLUMNS_TO_ENABLE_MULTIPLE_EXPANSION_AREAS: '2',
  PATIENT_JACKET_EXAM_COMMENTS: 'off',
  PIXEL_WORKER_DEDUPLICATION: 'on',
  VIEWER_SW_PORT_PRUNING: 'on',
  VIEWER_SW_GENERATION_BUMP: 'on',
  PREFETCH_CLAIMED_WORKLIST_ITEMS: 'off',
  PREFETCH_HOVERED_WORKLIST_ITEM: 'off',
  PREFETCH_READ_CASE_ITEM: 'off',
  PREFETCH_TOP_WORKLIST_ITEMS: 'on',
  PREFETCH_TOP_WORKLIST_ITEMS_BIG_BATCHING: '5',
  PREFETCH_TOP_WORKLIST_ITEMS_LARGE: '20',
  PREFETCH_TOP_WORKLIST_FULL_STACKS: '0',
  PREFETCH_FULL_STACK_MAX_MB_PER_CASE: '750',
  REPORT_FACADE: 'off',
  REPORTER_ANATOMIC_NAVIGATOR: 'off',
  REPORTER_ASR_PLEX: 'on',
  REPORTER_AUTO_IMPRESSIONS: 'off',
  REPORTER_AUTO_IMPRESSIONS_MODALITY_SCOPE: 'off',
  REPORTER_DICTATION_MARKS: 'off',
  REPORTER_EXPANDED_GROUPABLE_STATUSES: 'off',
  REPORTER_HEADING_NODES_DEPRECATED: 'off',
  REPORTER_HIDE_HYPOTHESIS_TEXT: 'off',
  REPORTER_MARK_AS_DISCREPANT: 'off',
  REPORTER_MACRO_PLACEHOLDER_CHIP: 'off',
  REPORTER_NESTED_MACROS: 'off',
  REPORTER_PICKLIST_OPTION_BY_NAME: 'off',
  REPORTER_PROGRAMMABLE_MICROPHONE_BUTTONS: 'off',
  REPORTER_RECORD_BUTTON_REDESIGN: 'off',
  REPORTER_RIGHT_DRAWER_TABLE_VIRTUALIZATION: 'off',
  REPORTER_SHOW_DICTATION_STEP_NOTIFICATIONS: 'off',
  REPORTER_TEXT_EDITOR_RECORDER_BORDER: 'off',
  REPORTER_WORKSTATION_ID: 'off',
  REPORTER_WEBHID: 'off',
  REPORT_CONTENT_UNMASKED: 'off',
  SEARCH_PAGE: 'off',
  SHOW_MOUSE_SENSITIVITY_SETTINGS: 'off',
  SLATE_OPS_LOG: 'on',
  URT_ENABLED: 'off',
  USE_INVERTED_IMAGE_DETECTION: 'on',
  VIEWER_RESET_CACHE_ON_REFRESH: 'off',
  VIEWER_PRECACHE_WAIT_FOR_STUDY_READY: 'off',
  VIEWER_MEMORY_OFFSET_GB: '0',
  VIEWER_MACHINE_MEMORY_BUDGET: 'off',
  VIEWER_SLICE_MEMORY_OVERHEAD_FACTOR: '1.5',
  VIEWER_RESTRICT_INITIAL_LOADS: 'off',
  VIEWER_STEP_AWARE_LOAD_PRIORITY: 'off',
  VIEWER_CACHE_STRATEGY: 'idb',
  VIEWER_MAX_PARALLEL_PIXEL_REQUESTS: 'off',
  VIEWER_RECORD_BUTTON: 'off',
  WORKLIST_AUTO_LOAD: 'on',
  WORKLIST_AUTOLOAD_BACKEND: 'off',
  WORKLIST_COLUMN_MANAGEMENT_DRAWER: 'off',
  WORKLIST_COUNT_CACHE_TTL_MS: 'off',
  WORKLIST_CONTEXT_REFACTOR: 'off',
  WORKLIST_DICOM_SEND: 'off',
  WORKLIST_PERFORMANCE_OPTIMIZATION: 'off',
  WORKLIST_INGESTION_TIMEOUT: '0',
  WORKLIST_PENDING_TO_READY_TO_READ: 'off',
  WORKLIST_POLL_INTERVAL: '60000',
  WORKLIST_RECENTLY_READ_DAYS: '7',
  WORKLIST_REPORT_STATUS_COLUMN: 'off',
  WORKLIST_STICKY_FILTERS_DISABLED: 'off',
  WORKLIST_TABLE_REFACTOR: 'off',
  WORKLIST_UNIFIED_FIELDS: 'off',
  WORKLIST_SLA: 'off',
  WORKSPACE_LAYOUT_V2: 'off',
  refresh_viewer_on_new_case: 'off',
  REFRESH_REPORTER_ON_NEW_CASE: 'off',
  VIEWPORT_TYPE_THREE_D_DRE_ENABLED: 'on',
  IMAGE_REGISTRATION_ALIGNMENT: 'off',
  IMAGE_REGISTRATION_MODEL_VERSION: 'any',
  PET_CT_OVERLAY_ENABLED: 'off',
  REPORTER_EXAM_COUNT: 'on',
  FAST_ANNOTATIONS: 'off',
  REPORTER_MODIFY_DICTATION: 'off',
  MG_CAD_SR_TEXT_RENDER: 'off',
  MOVE_TO_QUALITY_CONTROL: 'off',
  ARCHIVE_SEARCH: 'off',
  REPORTER_PRELIM: 'off',
  QC_STATUS_COLUMN: 'off',
  DICOM_EDITING: 'off',
  PET_CT_SUV_EDITABLE: 'off',
  LOCALIZE_MULTI_AXES: 'on',
  DICOM_RESTORE: 'off',
  DICOM_MISMATCH: 'off',
  MULTI_OBJECT_STACKS: 'off',
  WINDOW_LEVEL_DIRECT_MANIPULATION: 'off',
  SESSION_REPLAY_CONFIG: 'off',
});
export type FeatureFlag = (typeof FF)[keyof typeof FF];
